import React from "react";

export default function Kpis({ stats, loading, tiles }) {
    return (
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
            {tiles.map(({ label, icon, key }) => (
                <StatTile
                    key={key}
                    className="w-full"
                    isLoading={loading}
                    number={stats?.[key] ?? 0}
                    label={label}
                    icon={icon}
                />
            ))}
        </div>
    );
}

function StatTile({ number, label, isLoading = false, className = "", icon }) {
    return (
        <div className={`rounded-2xl bg-white p-3 flex items-center gap-4 ${className}`}>
            <div className="h-14 w-14 rounded-lg bg-[#F7F8FD] grid place-items-center">{icon}</div>
            <div>
                <div className="text-[20px] font-[550] text-[#383B56]">
                    {isLoading ? (
                        <span className="inline-block h-6 w-10 rounded animate-pulse bg-[#F4F0FF]" />
                    ) : (
                        number
                    )}
                </div>
                <div className="text-[14px] font-[350] text-[#383B56]">{label}</div>
            </div>
        </div>
    );
}
